

export function getPaths(sdApi, filters) {
  if (sdApi) {
    const paths = sdApi.scene
      .get(null, "CommPlugin_1")
      .data.filter(
        (p) =>
          filters.includes(p.name.split("_")[0]) && Object.prototype.hasOwnProperty.call(p, "bbmin")
      )
      .map((q) => q.scenePath);
    // console.log(`paths for ${JSON.stringify(filters)}: ${paths}`);
    return paths;
  }
  return null;
}

export function getCenterPivot(sdApi, assetName) {
  if (sdApi.current) {
    const centerAsset = sdApi.current.scene
      .get(null, "CommPlugin_1")
      .data.filter((p) => p.name === assetName && Object.prototype.hasOwnProperty.call(p, "bbmin"))[0];

    const pivot = {
      x: (centerAsset.bbmin[0] + centerAsset.bbmax[0]) / 2,
      y: (centerAsset.bbmin[1] + centerAsset.bbmax[1]) / 2,
      z: (centerAsset.bbmin[2] + centerAsset.bbmax[2]) / 2,
    };
    return pivot;
  }
  return null;
}

// goal: change dynamic data storage to array of type "ParameterUpdateObject":
// https://viewer.shapediver.com/v2/2.10.1/doc/module-ApiInterfaceV2-ApiParameterInterface.html#updateAsync

/**
 *
 * @param {*} paramData ParamData Array from ShapeDiver or Static data set.
 * returns Array of params in format: [{id, name, value}, ...]
 * but needs to return all in a single object...
 * also should filter hidden (?)
 */
export function getParamObjs(paramData) {
  var paramObjs = [];

  for (let entry of paramData) {
    // console.log(`entry: ${JSON.stringify(entry)}`);
    let paramObject = {
      id: entry.id,
      name: entry.name,
      value: entry.value,
    };
    paramObjs.push(paramObject);
  }
  // console.log(`JSON.stringify(paramObjs): ${JSON.stringify(paramObjs)}`);
  return paramObjs;
}


  /**
   * logic from  https://gamedev.stackexchange.com/questions/28249/calculate-new-vertex-position-given-a-transform-matrix
   * @param {*} point - point{x,y,z} to transform
   * @param {*} m - array[16] - 3d transform matrix
   */
  export function applyTransform(point, m){
    const { x, y, z } = point;
    const w = 1;
    const tX = m[0] * x + m[1] * y + m[2] * z + m[3] * w;
    const tY = m[4] * x + m[5] * y + m[6] * z + m[7] * w;
    const tZ = m[8] * x + m[9] * y + m[10] * z + m[11] * w;
    const tW = m[12] * x + m[13] * y + m[14] * z + m[15] * w;
    const pointTformed = { x: tX / tW, y: tY / tW, z: tZ / tW };

    return pointTformed;
  }

  export function  resetPoints(sphPoints) {
    sphPoints.current = [
      [0, 0, 0],
      // [null], //this works - use nulls as placeholders if adding and removing points
      [0, 0.333333, 0],
      [0, 0.666667, 0],
      [0, 1, 0],
      [0, 0, 0],
      [0, 0.333333, 0],
      [0, 0.666667, 0],
      [0, 1, 0],
    ];
    return sphPoints;
    
  }